// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3d1b0aa9","455":"0b4acc6c","488":"4f702d3d","977":"dfe542fb"}[chunkId] + ".chunk.js";
};